import { isEmpty } from 'lodash';
import checkIsVariantEnabled from './checkIsVariantEnabled';
import checkIsVariantForPrice from './checkIsVariantForPrice';
import { formatPriceInput } from '../services/formatPrice';
import isPwywOption from './isPwywOption';

function applyPayWhatYouWantAmount(option, formOption, currency) {
  if (!isPwywOption(option)) return option;

  const result = { ...option };

  if (formOption?.payWhatYouWantAmount != null && formOption.payWhatYouWantAmount !== '') {
    const convertedAmount = Number(formatPriceInput(formOption.payWhatYouWantAmount, currency));
    if (!isNaN(convertedAmount)) {
      result.additionalChargeAmount = convertedAmount;
    } else {
      result.additionalChargeAmount = 0;
    }
  } else {
    result.additionalChargeAmount = 0;
  }

  return result;
}

export default function getSelectedVariants(
  productVariants,
  formVariants,
  currency,
  selectedPriceId,
) {
  if (!productVariants || !productVariants.length) return [];
  if (!formVariants || isEmpty(formVariants)) return [];

  const variants = Object.keys(formVariants)
    .map(variantId => {
      const variant = productVariants.find(v => v._id === variantId);

      if (!variant) return null;

      if (!checkIsVariantForPrice(variant, selectedPriceId)) return null;

      // if quantity select is enabled, we loop through each selected option and store as selectedOptions
      if (variant.selectionType === 'quantity') {
        const selectedOptions = formVariants[variantId];

        if (!selectedOptions || !selectedOptions.length) return null;

        const visible = checkIsVariantEnabled(variant, formVariants, productVariants);

        if (!visible) {
          return null;
        }

        variant.selectedOptions = variant.options
          .filter(o => selectedOptions.find(so => so.optionId === o._id))
          .map(o => {
            const selectedOption = selectedOptions.find(so => so.optionId === o._id);

            return applyPayWhatYouWantAmount(
              {
                ...o,
                quantity: selectedOption.quantity,
              },
              selectedOption,
              currency,
            );
          });

        return variant;
      } else if (variant.selectionType === 'multiple') {
        const selectedOptions = formVariants[variantId];

        if (!selectedOptions || !selectedOptions.length) return null;

        const visible = checkIsVariantEnabled(variant, formVariants, productVariants);

        if (!visible) {
          return null;
        }

        variant.selectedOptions = variant.options
          .filter(o => selectedOptions.find(so => so.optionId === o._id))
          .map(o => {
            const selectedOption = selectedOptions.find(so => so.optionId === o._id);

            return applyPayWhatYouWantAmount(
              {
                ...o,
                quantity: selectedOption.quantity,
              },
              selectedOption,
              currency,
            );
          });

        return variant;
      } else if (variant.selectionType === 'single') {
        const selectedOption = formVariants[variantId].find(o => o.quantity > 0);

        if (!selectedOption) return null;

        const visible = checkIsVariantEnabled(variant, formVariants, productVariants);

        if (!visible) {
          return null;
        }

        const option = variant.options?.find(o => o._id === selectedOption.optionId);

        variant.selectedOption = option
          ? applyPayWhatYouWantAmount(option, selectedOption, currency)
          : option;

        return variant;
      }
    })
    .filter(Boolean);

  return variants;
}
